import { status } from '../utils';

export function getEvent(token, id){
  return fetch(`${process.env.REACT_APP_API_URL}/events/${id}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  })
  .then(status).catch( e => {console.log(e)})
}

export function createEvent(token, data){
  return fetch(`${process.env.REACT_APP_API_URL}/events/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify(data)
  })
  .then(status).catch( e => {console.log(e)})
}

export function updateEvent(token, id, data){
  return fetch(`${process.env.REACT_APP_API_URL}/events/${id}/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify(data)
  }).then(status)
}

export function getBetHistory(token, userId, groupId){
  return fetch(`${process.env.REACT_APP_API_URL}/bets/history/?user=${userId}&group=${groupId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  }).then(status)
}

export function placeBet(token, item){
  return fetch(`${process.env.REACT_APP_API_URL}/bets/place_bet/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify(item)
  })
  .then(status).catch( e => {console.log(e)})
}

export function setResults(token, item){
  return fetch(`${process.env.REACT_APP_API_URL}/events/${item.event}/set_result/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify(item)
  })
  .then(status).catch( e => {console.log(e)})
}